import { Select, SelectProps } from 'antd';
import { useTranslation } from 'react-i18next';

const { Option } = Select;

interface OptionType {
    value: string | number;
    label: string;
}

interface SearchableSelectProps extends Omit<SelectProps<any>, 'options'> {
    options: OptionType[];
}

const SearchableSelect = ({ options, ...props }: SearchableSelectProps) => {
    const { i18n } = useTranslation();

    const filterOption = (input: string, option: any) =>
        (option!.children as unknown as string)
            .toLocaleLowerCase(i18n.language)
            .includes(input.toLocaleLowerCase(i18n.language));

    return (
        <Select
            showSearch
            optionFilterProp="children"
            filterOption={filterOption}
            {...props}
        >
            {options.map(option => (
                <Option key={option.value} value={option.value}>
                    {option.label}
                </Option>
            ))}
        </Select>
    );
};

export default SearchableSelect;